import axios from 'axios';
import { getSapJobsApiRoot } from '@/lib/dashboardApi';

function encodePathSegment(value) {
  return encodeURIComponent(String(value || ''));
}

function apiRoot() {
  const root = getSapJobsApiRoot();
  if (!root) {
    throw new Error('Dashboard API base URL is not configured');
  }
  return root;
}

export async function fetchSapJobsList(params) {
  const { data } = await axios.get(apiRoot(), { params });
  return data;
}

export async function fetchSapMonitoredRuns(params) {
  const { data } = await axios.get(`${apiRoot()}/monitored-runs`, { params });
  return data;
}

export async function fetchSapUpcomingJobs(params) {
  const { data } = await axios.get(`${apiRoot()}/upcoming`, { params });
  return data;
}

export async function fetchSapJobDetail(monitorSlotId) {
  const id = encodePathSegment(monitorSlotId);
  const { data } = await axios.get(`${apiRoot()}/jobs/${id}`);
  return data;
}

export async function fetchSapJobRuns(monitorSlotId, { limit = 50, offset = 0 } = {}) {
  const id = encodePathSegment(monitorSlotId);
  const { data } = await axios.get(`${apiRoot()}/jobs/${id}/runs`, {
    params: { limit, offset },
  });
  return data;
}

export async function fetchSapJobMonitoring(monitorSlotId) {
  const id = encodePathSegment(monitorSlotId);
  const { data } = await axios.get(`${apiRoot()}/jobs/${id}/monitoring`);
  return data;
}

export async function fetchSapJobTimingProfile(monitorSlotId) {
  const id = encodePathSegment(monitorSlotId);
  const { data } = await axios.get(`${apiRoot()}/jobs/${id}/timing-profile`);
  return data;
}

export async function fetchSapJobRunDetail(runId) {
  const id = encodePathSegment(runId);
  const { data } = await axios.get(`${apiRoot()}/runs/${id}`);
  return data;
}

export function getSapJobsApiRootForTests() {
  return getSapJobsApiRoot();
}
